// import ReactDOM from 'react';
import Main from './Main';
import '../stylesheet/style.css';

function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
